import { Carousel } from "@mantine/carousel";
import "@mantine/carousel/styles.css";
import { Box, Button, Flex, Modal, ScrollArea, Stack } from "@mantine/core";
import Autoplay from "embla-carousel-autoplay";
import { useRef, useState } from "react";
import GlobalFileUploaderTable from "../../../../components/FileUploader/GlobalFileUploaderTable";
import WidgetWrapper from "../../../../components/WidgetWrapper/WidgetWrapper";
import { useAppSelector } from "../../../../hooks";
import { useGetFilesFromAzureBlobStorageQuery } from "../../../azureBlobStorageRTK";
const ImageSlideWidget: React.FC = () => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const layout = useAppSelector((state) => state.projectDashboardReducer.activeLayout);
  const globalEditMode = useAppSelector((state) => state.projectDashboardReducer.editMode);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const path = `${project._id}/projectdashboard/${layout._id}/files`;
  const projectId = project._id || (project as string);
  const {
    data: images,
    isLoading: loadingFiles,
    isError: errorFetchingFiles,
  } = useGetFilesFromAzureBlobStorageQuery({ projectId, path }, { skip: projectId == null });

  const SimpleSlider = ({ displayType }: { displayType: "contain" | "cover" }) => {
    // Only enable actions if there are at least 2 images
    const enableCarousal = images != null && images.length > 1;
    const autoplay = useRef(enableCarousal ? Autoplay({ delay: 3000 }) : null);

    if (!images || images.length === 0) {
      return null;
    }
    return (
      <Box style={{ width: "100%", height: "100%" }}>
        <Carousel
          withIndicators={enableCarousal}
          withControls={enableCarousal}
          slideSize="100%"
          slideGap="4px"
          height="100%"
          type="container"
          emblaOptions={{ loop: true, align: "center" }}
          style={{ width: "100%", height: "100%" }}
          plugins={enableCarousal && autoplay.current ? [autoplay.current] : []}
          onMouseEnter={enableCarousal && autoplay.current ? autoplay.current.stop : null}
          onMouseLeave={enableCarousal && autoplay.current ? () => autoplay.current!.play() : null}
        >
          {images.map((image, index) => (
            <Carousel.Slide key={image.blobName}>
              <img
                src={`/api/image/${image?.blobName}`}
                alt={image?.originalFileName || image?.blobName || "image"}
                style={{
                  borderRadius: "6px",
                  width: "100%",
                  height: "100%",
                  objectFit: displayType,
                }}
              />
            </Carousel.Slide>
          ))}
        </Carousel>
      </Box>
    );
  };

  return (
    <WidgetWrapper
      widgetKey="ImageSlide"
      title="Bilder"
      onFullscreenClick={true ? () => setOpenModal(true) : null}
      onShowSettingsClick={() => setEditMode(!editMode)}
    >
      <>
        <Flex direction="column" h="calc(100% - 40px)" w="100%">
          {images?.length > 0 ? (
            <>{editMode === false && <SimpleSlider displayType="cover" />}</>
          ) : (
            <Stack justify="center" align="center" h="100%" ta="center" onMouseDown={(e) => e.stopPropagation()}>
              {globalEditMode === false ? (
                <>
                  <p>Ingen bilder er lagret! Klikk her for å håndtere bilder:</p>
                  <Button color="mc-primary" variant="filled" style={{ zIndex: 3 }} onClick={() => setEditMode(true)}>
                    Håndtere Bilder
                  </Button>
                </>
              ) : (
                <Button disabled>Ingen bilder å vise</Button>
              )}
            </Stack>
          )}
        </Flex>
        {editMode && (
          <>
            <Modal
              opened={editMode}
              onClose={() => setEditMode(false)}
              title={"Håndtere Bilder"}
              size="60vw"
              overlayProps={{ blur: 2 }}
              yOffset={140}
            >
              <ScrollArea style={{ minHeight: 200, maxHeight: "70vh" }}>
                <GlobalFileUploaderTable
                  path={`${project._id}/projectdashboard/${layout._id}/files`}
                  imageOnly={true}
                />
              </ScrollArea>
            </Modal>
          </>
        )}
        {openModal && (
          <Modal
            withCloseButton={false}
            opened={openModal}
            onClose={() => setOpenModal(false)}
            size="80vw"
            centered
            overlayProps={{ blur: 2 }}
          >
            <Flex bg="gray.0" style={{ height: "60vh", borderRadius: 6 }}>
              <SimpleSlider displayType="contain" />
            </Flex>
          </Modal>
        )}
      </>
    </WidgetWrapper>
  );
};

export default ImageSlideWidget;
